import apiClient from './api';

export const fetchDashboardCards = async () => {
  const response = await apiClient.get('/api/dashboard/cards');
  return response.data;
};

export const createFollowUp = async (followUpData) => {
  const response = await apiClient.post('/api/dashboard/follow-ups', followUpData);
  return response.data;
};

export const markFollowUpDone = async (id) => {
  const response = await apiClient.patch(`/api/dashboard/follow-ups/${id}/done`);
  return response.data;
};

export const confirmInterviewByCandidate = async (id) => {
  const response = await apiClient.patch(`/api/dashboard/interviews/${id}/confirm-candidate`);
  return response.data;
};

export const confirmInterviewByClient = async (id) => {
  const response = await apiClient.patch(`/api/dashboard/interviews/${id}/confirm-client`);
  return response.data;
};

export const updateCandidatePipelineStage = async (id, stage) => {
  const response = await apiClient.patch(
    `/api/dashboard/candidates/${id}/pipeline-stage`,
    { stage }
  );
  return response.data;
};
